import { useEffect, useState } from "react";
import { Sparkles, Loader2, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { api, formatError, fmtDate } from "@/lib/api";

const List = ({ title, items, testId }) => (items?.length ? (
  <div data-testid={testId}>
    <p className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{title}</p>
    <ul className="mt-1.5 space-y-1 text-sm list-disc pl-5">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
  </div>
) : null);

export const LetterSummary = ({ mailId }) => {
  const [s, setS] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/mail/${mailId}/summary`).then((r) => setS(r.data.summary)).catch(() => setS(null)); }, [mailId]);
  const generate = async () => {
    setBusy(true);
    setErr("");
    try {
      setS((await api.post(`/mail/${mailId}/summary`)).data.summary);
    } catch (e) {
      setErr(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  if (s === undefined) return <Loader2 className="animate-spin text-emerald-600" />;
  if (!s) return (
    <div data-testid="summary-empty">
      <button data-testid="summarise-btn" onClick={generate} disabled={busy} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-500 transition-colors disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />} {busy ? "Summarising…" : "Summarise this letter"}
      </button>
      <p data-testid="summary-privacy-note" className="text-xs text-slate-500 mt-3 flex gap-1.5"><ShieldCheck size={13} className="text-emerald-600 shrink-0 mt-0.5" />
        <span>The letter text is processed by AI (Anthropic Claude) to create the summary. It's generated once, saved securely, and visible only to the sender and recipient. <Link to="/privacy" className="underline">Privacy</Link></span></p>
      {err && <p data-testid="summary-error" className="text-sm text-red-600 mt-2">{err}</p>}
    </div>
  );
  return (
    <div data-testid="summary-result" className="space-y-4">
      <p data-testid="summary-overview" className="text-sm leading-relaxed">{s.overview}</p>
      <List title="Key points" items={s.key_points} testId="summary-key-points" />
      <List title="What you need to do" items={s.actions} testId="summary-actions" />
      <List title="Deadlines" items={s.deadlines} testId="summary-deadlines" />
      <p className="text-[11px] text-slate-500 pt-2 border-t border-slate-100 dark:border-slate-800">AI-generated on {fmtDate(s.created_at)}. It may contain mistakes, so always check the original letter.</p>
    </div>
  );
};
